<template>
  <div class="row">
    <div class="w-50 px-1 text-center">
      <b-form-radio id="no" v-model="vModel" name="support" value="false"></b-form-radio>
      <label for="no">
        <p class="text-uppercase font-weight-bold text-info">{{ $t('props.no') }}</p>
      </label>
    </div>
    <div class="w-50 px-1 text-center">
      <b-form-radio id="yes" v-model="vModel" name="support" value="true"></b-form-radio>
      <label for="yes">
        <p class="text-uppercase font-weight-bold text-info mb-0">{{ $t('props.yes') }}</p>
        <b-img class="support__image" src="@/assets/images/coat-hanger-box/supports.png" fluid alt="supporti"></b-img>
      </label>
    </div>
  </div>
</template>
<script>
import { InputField } from '../Input.mixin'

export default {
  name: 'InputCoatHangerInternalSupport',
  extends: InputField,
  data () {
    return {
      vModel: this.value ? 'true' : 'false'
    }
  },
  watch: {
    vModel (value) {
      this.$emit('input', value === 'true')
    }
  }
}
</script>
<style>
  .support__image {
    height: 64px;
  }
</style>
